/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'paperclip': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M16.5 6v11.5a4 4 0 01-4 4 4 4 0 01-4-4V5A2.5 2.5 0 0111 2.5 2.5 2.5 0 0113.5 5v10.5a1 1 0 01-1 1 1 1 0 01-1-1V6H10v9.5a2.5 2.5 0 002.5 2.5 2.5 2.5 0 002.5-2.5V5a4 4 0 00-4-4 4 4 0 00-4 4v12.5a5.5 5.5 0 005.5 5.5 5.5 5.5 0 005.5-5.5V6h-1.5z"/>'
  }
})
